import {
  Close,
  Info,
  ChevronUp,
  ChevronDown,
} from '@volkswagen-onehub/icons-core';
import { isMobile } from '@/modules/utils/breakpoints';
import useResizeResponsive from '@/hooks/useResizeResponsive';

function DropdownIcon({ isOpen }: { isOpen: boolean }) {
  const isMobileWidth = useResizeResponsive(isMobile);

  const MobileIcons = () => (isOpen ? <Close /> : <Info />);
  const DesktopIcons = () => (isOpen ? <ChevronUp /> : <ChevronDown />);

  return isMobileWidth ? <MobileIcons /> : <DesktopIcons />;
}

export default DropdownIcon;
